import React from "react";
import "./style.css";
import numeral from "numeral";

const DeadlinesCard = props => {
  const { itemList, className, deadlines } = props;

  const getTotalAmountScaduti = () => {
    let listDeadlines = deadlines;
    const result = { toPayExpired: 0, toCollectExpired: 0 };
    if (!listDeadlines) {
      return result;
    }
    listDeadlines
      .filter(d =>
        d.status &&
          d.status.confirmed &&
          new Date(d.date) < new Date().setHours(
            0, 0, 0, 0
          ) &&
          (d.payment.status === "due" ||
            d.payment.status === "suspended" ||
            d.status.rejected))
      .forEach(currentDeadline => {
        if (currentDeadline.totalAmount < 0) {
          result.toPayExpired -= currentDeadline.totalAmount;
        } else {
          result.toCollectExpired += currentDeadline.totalAmount;
        }
      });
    return result;
  };

  function amountToString(amount) {
    return numeral(amount).format("0,0.00") + "€";
  }

  const getTotalMonth = listDeadlines => {
    const result = { toPay: 0, toCollect: 0 };
    if (!listDeadlines) {
      return result;
    }
    listDeadlines
      .filter(d => d.status && d.status.confirmed)
      .forEach(currentDeadline => {
        if (currentDeadline.totalAmount < 0) {
          result.toPay -= currentDeadline.totalAmount;
        } else {
          result.toCollect += currentDeadline.totalAmount;
        }
      });
    return result;
  };

  const getTotalAmountPagatiIncassati = () => {
    const result = { payed: 0, collected: 0 };
    let listDeadlines = deadlines;
    if (!listDeadlines) {
      return result;
    }
    listDeadlines
      .filter(d => d.status && d.status.confirmed && d.payment.status === "paid")
      .forEach(currentDeadline => {
        if (currentDeadline.totalAmount < 0) {
          result.payed -= currentDeadline.totalAmount;
        } else {
          result.collected += currentDeadline.totalAmount;
        }
      });
    return result;
  };

  const renderListCard = () => {
    let listCard = [];
    for (let s in itemList) {
      if (s) {
        let classAmount = "amountNormal";
        let totalAmountCard = 0;
        if (
          itemList[s] === "Scaduti" &&
          className === "deadlineCardPagamenti"
        ) {
          totalAmountCard = getTotalAmountScaduti().toPayExpired;
          classAmount = "amountNormal amountRed";
        } else if (
          itemList[s] === "Scaduti" &&
          className === "deadlineCardIncassi"
        ) {
          totalAmountCard = getTotalAmountScaduti().toCollectExpired;
          classAmount = "amountNormal amountRed";
        } else if (
          itemList[s] === "In scadenza" &&
          className === "deadlineCardPagamenti"
        ) {
          totalAmountCard = getTotalMonth(deadlines).toPay;
        } else if (
          itemList[s] === "In scadenza" &&
          className === "deadlineCardIncassi"
        ) {
          totalAmountCard = getTotalMonth(deadlines).toCollect;
        } else if (
          itemList[s] === "Pagati" &&
          className === "deadlineCardPagamenti"
        ) {
          totalAmountCard = getTotalAmountPagatiIncassati().payed;
        } else if (
          itemList[s] === "Incassati" &&
          className === "deadlineCardIncassi"
        ) {
          totalAmountCard = getTotalAmountPagatiIncassati().collected;
        }
        listCard.push(<div
          className={"cardSkeleton " + className}
          style={{
            maxHeight: "113px",
            minHeight: "113px",
            marginRight: "10px",
            flex: "1"
          }}
          key={s}
        >
          <div
            style={{
              marginLeft: "10px",
              marginTop: "15px",
              fontWeight: "normal"
            }}
          >
            {itemList[s]}
          </div>
          <div className={classAmount}>{amountToString(totalAmountCard)}</div>
        </div>);
      }
    }
    return listCard;
  };

  return (
    <div style={{ display: "flex", marginLeft: "23px", flex: "3" }}>
      {renderListCard()}
    </div>
  );
};

export default DeadlinesCard;
